import { Inject, Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/empty';
import { MissingWorkingDaysRequest } from './model/missing-working-days-request';
import { OnCallCalendarRequest } from './model/on-call-calendar-request';
import { LOADER_SERVICE } from '../shared/upgrade/loader.service';
import { DailyDetailsTreeRequest } from './model/daily-details-tree-request';
import { SYNC_SERVICE } from 'app/shared/upgrade/sync.service';
import { ApprovedDaysOffRequestsRequest } from './model/approved-days-of-requests-request';

import * as moment from 'moment';
import { DailyDetailsForEmployeeRequest } from './model/daily-details-for-employee-request';
import { ApproveDayOffRequests } from './model/approve-day-off-request';
import { WrapperService } from './wrapper.service';

@Injectable()
export class ApiService {

	constructor(@Inject(LOADER_SERVICE) private loaderService: any,
		@Inject(SYNC_SERVICE) private syncService: any,
		private wrapper: WrapperService) {
	}

	getMissingWorkingDays(data: MissingWorkingDaysRequest): Observable<any> {
		return this.wrapper.wrapPostRequest('/reports/missingDaysTree', data, 'getMissingWorkingDays');
	}

	getOnCallCalendar(data: OnCallCalendarRequest): Observable<any> {
		return this.wrapper.wrapGetRequest(`/reports/onCall/calendar/${data.year}`, 'getOnCallCalendar');
	}

	getDailyDetailsTree(data: DailyDetailsTreeRequest): Observable<any> {
		if (!data.disableLoader) {
			this.loaderService.showLoader();
		}

		const employees: number[] = (this.syncService.handlers['ttEmployeeFilter_' + data.parentTab] === undefined)
			? []
			: this.syncService.invokeHandler('ttEmployeeFilter_' + data.parentTab, 'getEmployeeFilterIds');

		let billingCodes: number[];
		if (data.billingCodes === undefined) {
			billingCodes = (this.syncService.handlers['BillingCodeFilterController'] === undefined)
				? []
				: this.syncService.invokeHandler('BillingCodeFilterController', 'getBillingCodeFilterIds');
		} else {
			billingCodes = data.billingCodes;
		}

		const requestData: { employees: number[], billingCodes: number[] } = {
			employees: employees,
			billingCodes: billingCodes
		};

		return this.wrapper.wrapPostRequest(`/reports/dailyDetailsTree/${data.year}/${data.month}/${data.day}`, requestData, 'getDailyDetailsTree')
			.do(() => this.loaderService.hideLoader())
			.catch((response: Response) => {
				this.loaderService.hideLoader();
				return Observable.throw(response);
			});
	}

	getApprovedDaysOffRequests(data: ApprovedDaysOffRequestsRequest): Observable<any> {
		const startDate: string = moment(data.startDate).format('MM-DD-YYYY'),
			endDate: string = moment(data.endDate).format('MM-DD-YYYY');
		return this.wrapper.wrapGetRequest(`/reports/daysOffRequests/approved/${startDate}/${endDate}`, 'getApprovedDaysOffRequests');
	}

	getDailyDetailsForEmployee(data: DailyDetailsForEmployeeRequest): Observable<any> {
		return this.wrapper.wrapGetRequest(`/reports/dailyDetails/${data.year}/${data.month}/${data.day}/${data.id}`, 'getDailyDetailsForEmployee');
	}

	getUnapprovedDaysOffRequests(): Observable<any> {
		return this.wrapper.wrapGetRequest('/reports/daysOffRequests/unapproved', 'getUnapprovedDaysOffRequests');
	}

	getTimeCardsWaitingForApproval(): Observable<any> {
		return this.wrapper.wrapGetRequest('/reports/timecards/waiting', 'getTimeCardsWaitingForApproval');
	}

	approveDayOffRequest(data: ApproveDayOffRequests): Observable<any> {
		return this.wrapper.wrapPostRequest('/reports/approveDayOffRequest', data, 'approveDayOffRequest');
	}

	getTimeEntryNoteTemplates(): Observable<any> {
		return this.wrapper.wrapGetRequest('/settings/templates', 'getTemplatesForSettings');
	}

	getBillingCodes(params?: any): Observable<any> {
		params = params || {};
		return this.wrapper.wrapGetRequest('/settings/billingCodes', 'getBillingCodes');
	}

	saveTemplate(params: any): Observable<any> {
		params = params || {};
		return this.wrapper.wrapPostRequest('/settings/templates', params, 'saveTemplate');
	}

	deleteTemplate(id: number): Observable<any> {
		return this.wrapper.wrapDeleteRequest('/settings/templates/' + id, {}, 'deleteTemplate');
	}

	getTasks(): Observable<any> {
		return this.wrapper.wrapGetRequest('/settings/tasks', 'getTasks');
	}

	getAllEmployees(data?: any): Observable<any> {
		data = data || {};
		data.params = data.params || {};
		return this.wrapper.wrapGetRequestWithParams('/reports/allEmployees', data.params, 'getAllEmployees');
	}

	getEmployees(data?: any): Observable<any> {
		data = data || {};
		data.params = data.params || {};
		return this.wrapper.wrapGetRequestWithParams('/reports/employees', data.params, 'getEmployees');
	}

	getSubmittedTimecards(data: any): Observable<any> {
		return this.wrapper.wrapPostRequest('/reports/timecards/submitted', data, 'getSubmittedTimecards');
	}

	getAllEmployeesRolesCount(): Observable<any> {
		return this.wrapper.wrapGetRequestWithParams('/reports/allEmployeesCount', {}, 'getAllEmployeesRolesCount');
	}
	getProjects(args: any): Observable<any> {
		const countActualHours: string = (args.countActualHours ? args.countActualHours : false);
		const startDate: string = (args.startDate ? args.startDate : false);
		const endDate: string = (args.endDate ? args.endDate : false);
		const url: string = '/settings/projects/filter';
		return this.wrapper.wrapPostRequest(url, { countActualHours: countActualHours, startDate: startDate, endDate: endDate }, 'getProjects');
	}

	getDaysOffDetailsForTheRange(startDate: string, endDate: string, employees?: number[]): Observable<any> {
		const data: any = {
			startDate: startDate,
			endDate: endDate,
			employees: employees
		};

		return this.wrapper.wrapPostRequest('/reports/daysOff/range', data, 'getDaysOffDetailsForTheRange');
	}

	sendEmployeeDailyReport(date: string, employeeId: number): Observable<any> {
		return this.wrapper.wrapPostRequest(`/reports/employeeDailyReport/${date}/${employeeId}`, {}, 'sendEmployeeDailyReport');
	}

}



// WEBPACK FOOTER //
// ./src/app/api/api.service.ts